const appConfig = {
  AUDIO_ONLY: false,
  IS_PLATFORM_INTEGRATED: false,
  IS_CUSTOMIZE: false,
};

export default appConfig;
